import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import InstanceFields from './InstanceFields';
import { storeWithExpiration } from '../../../utils/common';
import { getInstallMeta } from '../../../actions/customerPortal';

export class InstanceFieldsContainer extends React.Component {
  static propTypes = {
    data: PropTypes.object.isRequired,
    getInstallMetaAction: PropTypes.func.isRequired,
    installMeta: PropTypes.object,
  };

  static defaultProps = {
    installMeta: null,
  };

  constructor(props) {
    super(props);
    this.handleConfigRefresh = this.handleConfigRefresh.bind(this);
  }

  state = { accordionsOpen: [] };

  componentWillMount = () => {
    this.getConfig();
  };

  getConfig = () => {
    const { getInstallMetaAction, data } = this.props;
    const token = storeWithExpiration.get('token');
    const { installation } = data;
    const installId = installation.get('id');
    getInstallMetaAction(installId, token);
  };

  getSelectedFieldsSize = fields => {
    const selected = fields.filter(field => field.status.statusType === 'OK');
    return selected.length;
  };

  setObjectStatusIcon = (object, passingFields, totalFields) => {
    let objectStatusColor = 'ellipsis-h text-warning';
    if (object.status.statusType === 'OK' && passingFields === totalFields) {
      objectStatusColor = 'check-circle text-success';
    } else if (object.status.statusType !== 'OK') {
      objectStatusColor = 'times-circle text-danger';
    }
    return objectStatusColor;
  };

  setObjectStatusMsg = (object, passingFields, totalFields) => {
    let objectStatusMsg = object.status.statusType;
    if (object.status.statusType === 'OK' && passingFields !== totalFields) {
      objectStatusMsg = 'One Or More Fields Not Configured';
    }
    return objectStatusMsg;
  };

  handleConfigRefresh = evt => {
    evt && evt.preventDefault();
    this.getConfig();
  };

  toggleAccordion = newAccordionId => {
    const { accordionsOpen } = this.state;
    const location = accordionsOpen.indexOf(newAccordionId);
    let updatedAccordionsOpen = [];

    // Only one accordion should be open at a time
    if (location < 0) updatedAccordionsOpen = [newAccordionId];

    this.setState({ accordionsOpen: updatedAccordionsOpen });
  };

  render() {
    const { installMeta } = this.props;
    const { accordionsOpen } = this.state;
    return installMeta ? (
      <div className="modal-wrap">
        <div className="row row-top">
          <div className="col-xs-12">
            <button className="btn btn-primary pull-right" onClick={this.handleConfigRefresh}>
              Refresh Configuration
            </button>
            <h1>Instance Fields</h1>
          </div>
        </div>
        <InstanceFields
          accordionsOpen={accordionsOpen}
          getSelectedFieldsSize={this.getSelectedFieldsSize}
          installMeta={installMeta}
          setObjectStatusIcon={this.setObjectStatusIcon}
          setObjectStatusMsg={this.setObjectStatusMsg}
          toggleAccordion={this.toggleAccordion}
        />
      </div>
    ) : null;
  }
}

function mapStateToProps(state) {
  const { customerPortalData } = state;
  const installMeta = customerPortalData.get('installMeta');
  return { installMeta };
}

export default connect(mapStateToProps, {
  getInstallMetaAction: getInstallMeta,
})(InstanceFieldsContainer);
